<template>
  <div id="adjunto-data">
    <input
      v-if="tipeView != 'consulta'"
      type="file"
      id="visita-file"
      name="visitaFile"
      :accept="tipeArchive"
      color="primary"
      dark
      :class="['mb-2', clase]"
      @change="processFile"
      multiple
    /><v-text-field
      v-if="tipeView == 'oculto'"
      v-model="filenameValue"
      label="Filename"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
      @input="$v.filename.$touch()"
      @blur="tipeView == 'crear' ? $v.filename.$touch() : null"
    ></v-text-field>
    <v-text-field
      v-if="tipeView == 'oculto'"
      v-model="idCalidadValue"
      label="id Calidad"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
    ></v-text-field>
    <v-text-field
      v-if="tipeView == 'oculto'"
      v-model="base64Value"
      label="Encrypt"
      :box="(isDisabled = true)"
      :readonly="(isDisabled = true)"
      @input="$v.base64Value.$touch()"
      @blur="tipeView == 'crear' ? $v.base64Value.$touch() : null"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "AdjuntoData",
  components: {},
  props: {
    centrotab: String,
    tipeView: String,
    tipeArchive: String,
    clase: String,
  },
  data() {
    return {
      contratoId: "",
      base64Value: "",
      filenameValue: "",
      base64Value2: "",
      filenameValue2: "",
      base64Value3: "",
      filenameValue3: "",
      base64Value4: "",
      filenameValue4: "",
      filex: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onloadend = (file) => {
          resolve(reader.result.split(",")[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async processFile(e) {
      try {
        let file = e.target.files[0];

        this.filenameValue = file.name;
        this.base64Value = await this.readFileAsync(file);
        this.$parent.base64Value = this.base64Value;
        this.$parent.filenameValue = this.filenameValue;
      } catch (err) {
        console.log("Error adjunto data:" + err);
      }
      this.$parent.$parent.base64Value = this.base64Value;
      this.$parent.$parent.filenameValue = this.filenameValue;
      this.$parent.$parent.$parent.base64Value = this.base64Value;
      this.$parent.$parent.$parent.filenameValue = this.filenameValue;
      this.$parent.$parent.$parent.$parent.base64Value = this.base64Value;
      this.$parent.$parent.$parent.$parent.filenameValue = this.filenameValue;
    },
    //Guardado en el store
    //this.base64Value = this.$store.getters.base64Stored;
    //this.filenameValue = this.$store.getters.filenameStored;
  },
};
</script>
